/* Two study cohorts; same draw timing as the NAD/NMN research component. */
(() => {
  if (!window.customElements || customElements.get('oxidane-age-research')) return;
  class OxidaneAgeResearch extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.lines = [...this.querySelectorAll('.nmn-reference-study-trend')];
      this.marks = [...this.querySelectorAll('.nmn-reference-plot-marks > g')];
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => { if (this.motion.matches) this.finish(); };
      this.motion.addEventListener('change', this.onMotionChange);
      if (this.motion.matches || !('IntersectionObserver' in window) || this.lines.some(line => !line.animate)) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        const duration = 1400;
        this.marks.forEach(mark => { mark.style.opacity = '0'; });
        this.animations = this.lines.map(line => {
          const length = line.getTotalLength();
          const frame = { strokeDasharray: String(length) };
          return line.animate([{ ...frame, strokeDashoffset: String(length) }, { ...frame, strokeDashoffset: '0' }], { duration, easing: 'cubic-bezier(.2,.7,.2,1)' });
        });
        const box = this.lines[0].getBBox();
        this.timers = this.marks.map(mark => {
          const m = mark.getBBox();
          const at = box.width ? Math.min(1, Math.max(0, (m.x + m.width / 2 - box.x) / box.width)) : 1;
          return window.setTimeout(() => { mark.style.opacity = '1'; }, duration * at * .9);
        });
      }, { threshold: .45, rootMargin: '0px 0px -10% 0px' });
      this.observer.observe(this.querySelector('svg'));
    }
    finish() {
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      this.timers?.forEach(window.clearTimeout);
      this.marks?.forEach(mark => { mark.style.opacity = '1'; });
    }
    disconnectedCallback() {
      this.finish();
      this.motion?.removeEventListener('change', this.onMotionChange);
      this.started = false;
    }
  }
  customElements.define('oxidane-age-research', OxidaneAgeResearch);
})();
